import React from 'react';

import { useAtom } from 'jotai';

import { useAccountInfo, useActiveLoanInfo } from '@consumer-frontend/api';
import {
  ListGroup,
  ListGroupItem,
  Nav,
} from '@consumer-frontend/shared-ui';

import { NavSelection } from './NavSelection';
import { accountIdAtom } from '../../store';
import { Error } from '../Error';

import '@consumer-bootstrap/index.scss';
import '@consumer-bootstrap/pages/account-home/nav.scss';

type CnuNavPropsT = {
  responsiveFlexClass: 'd-flex' | 'd-md-flex';
  displayNone?: boolean;
  hasBoxShadow?: boolean;
};

export type CnuNavT = React.FC<CnuNavPropsT>;

export const CnuNav: CnuNavT = ({
  displayNone,
  responsiveFlexClass,
  hasBoxShadow,
}) => {
  const navClasses = [
    displayNone ? 'd-none' : '',
    responsiveFlexClass,
    'container',
    'flex-column',
    'justify-content-between',
    hasBoxShadow ? 'shadow-sm' : 'shadow-none',
    'rounded',
    'cnu-nav',
  ].join(' ');

  const [accountId] = useAtom(accountIdAtom);

  const {
    accountInfo,
    error,
    isLoading,
  } = useAccountInfo(accountId);

  const {
    activeLoanInfo,
    isLoading: isActiveLoanLoading,
  } = useActiveLoanInfo(accountId);

  return (
    <Nav className={navClasses} id="cnu-nav" navbarScroll>
      <ListGroup className="list-group" variant="flush">
        {(isLoading || isActiveLoanLoading) && 'Loading...'}
        {error && <Error message={error.message} />}
        {accountInfo && (
          <ListGroupItem className="list-group-item pb-5">
            <h3 className="mb-1">Hello, {`${accountInfo.first_name}`}</h3>
            <strong>Account #{accountInfo.account_id}</strong>
          </ListGroupItem>
        )}
        <NavSelection loanInfo={activeLoanInfo} />
      </ListGroup>
    </Nav>
  );
};
